const customEmailTemplatesKeys = {
    customEmailTemplates: () => ['custom-email-templates'],
    detail: (id: string) => [
        ...customEmailTemplatesKeys.customEmailTemplates(),
        id,
    ],
    customEmailTemplatesMessages: (templateId: string) => [
        'custom-email-template-messages',
        templateId,
    ],
};

export default customEmailTemplatesKeys;
